import { theme } from '../../../theme';

export enum FnPerfectScrollbarVariants {
  Primary = 'primary',
  Secondary = 'secondary'
}

export const TRACK_BACKGROUND: Record<FnPerfectScrollbarVariants, string> = Object.freeze({
  [FnPerfectScrollbarVariants.Primary]: theme.colors.primaryHover,
  [FnPerfectScrollbarVariants.Secondary]: theme.filters.scrollbarTrack
});

export const TRACK_OPACITY: Record<FnPerfectScrollbarVariants, number> = Object.freeze({
  [FnPerfectScrollbarVariants.Primary]: 0.6,
  [FnPerfectScrollbarVariants.Secondary]: 1
});

export const THUMB_BACKGROUND: Record<FnPerfectScrollbarVariants, string> = Object.freeze({
  [FnPerfectScrollbarVariants.Primary]: theme.colors.line,
  [FnPerfectScrollbarVariants.Secondary]: theme.colors.secondary
});

export const THUMB_OPACITY: Record<FnPerfectScrollbarVariants, number> = Object.freeze({
  [FnPerfectScrollbarVariants.Primary]: 0.7,
  [FnPerfectScrollbarVariants.Secondary]: 1
});
